import { useQuery } from 'react-query';
import { queryKeys } from './queryKeys';
import { ManageExcessCashDTO } from '../../ManageExcessCashModal/ManageExcessCashModal.meta';
import { authFetch } from '../../CommonUtils/authFetch';
import { useSelector } from 'react-redux';
import { selectCurrentClient } from '../../CommonSelectors/CommonAreaSelector';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { useRouteParams } from '../hooks/useRouteParams';
import { MESSAGES } from '../../CommonConstants';

const URLS_MAP = {
  ClientSettings: 'Consumer/ClientSettings/GetClientExcessCashAllocation',
  MySettings: 'Adviser/Settings/GetMyExcessCashAllocation',
  FirmSettings: 'Adviser/Settings/GetFirmExcessCashAllocation',
};

const fetchManageExcessCash = (url: string) => async (
  clientId?: number,
): Promise<ManageExcessCashDTO> => {
  return authFetch(urlWithParams(url, { ...(clientId ? { clientId } : {}) }));
};

export const useManageExcessCashQuery = () => {
  const currentClient = useSelector(selectCurrentClient);
  const { page } = useRouteParams();
  return useQuery(
    queryKeys.getExcessCashOptions(!!currentClient?.Id, page),

    () => {
      if (currentClient?.Id) {
        return fetchManageExcessCash(URLS_MAP.ClientSettings)(currentClient.Id);
      }

      if (page) {
        return fetchManageExcessCash(URLS_MAP[page])();
      }

      throw new Error(MESSAGES.GENERIC_ERROR);
    },
    { cacheTime: 0 },
  );
};
